var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 108,
    height: 70,
    viewBox: "0 0 108 70",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M20 65h68V35H20z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M73 50c0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15-8.284 0-15 6.716-15 15M5 50c0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15-8.284 0-15 6.716-15 15"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M63 36c0 6.628 5.82 12 13 12s13-5.372 13-12c0-6.627-5.82-12-13-12s-13 5.373-13 12M23 36a7 7 0 1 0 14 0 7 7 0 0 0-14 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M27 26c0 12.15 9.85 22 22 22s22-9.85 22-22S61.15 4 49 4s-22 9.85-22 22"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "M18.893 68.818v-.182c-4.834 0-9.215-1.972-12.39-5.157a17.556 17.556 0 0 1-5.14-12.428c0-9.686 7.847-17.569 17.498-17.586h.145l.032-.142a9.835 9.835 0 0 1 4.397-6.223l.087-.054-.002-.103v-.202c0-6.997 2.836-13.34 7.417-17.936 4.582-4.596 10.905-7.441 17.88-7.441 11.933 0 22.126 8.351 24.678 19.804l.039.176.176-.037a14.358 14.358 0 0 1 2.97-.308c7.261 0 13.288 5.412 14.28 12.426l.02.14.138.015c8.722 1.004 15.52 8.457 15.519 17.47 0 4.85-1.966 9.245-5.14 12.43-3.175 3.184-7.557 5.156-12.39 5.156H18.893V69h70.214C98.974 69 107 60.949 107 51.05c0-9.2-6.936-16.806-15.84-17.831l-.02.18.179-.025c-1.017-7.192-7.194-12.738-14.64-12.74-1.031 0-2.049.106-3.044.316l.037.179.177-.04C71.261 9.47 60.922 1 48.816 1c-14.149 0-25.66 11.547-25.66 25.741 0 .068 0 .137.002.206l.181-.001-.096-.155a10.2 10.2 0 0 0-4.56 6.453l.178.04V33.1C9.008 33.12 1 41.164 1 51.051 1 60.949 9.026 69 18.893 69v-.182"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M45 69h18V45H45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M53.214 29.353l-13.97 16.01c-.564.648-.089 1.637.786 1.637h27.94c.875 0 1.35-.99.785-1.637l-13.97-16.01a1.05 1.05 0 0 0-1.57 0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload_icon.b75c77ba.svg";
export { ForwardRef as ReactComponent };